import { setCreateTransferStatus } from "actions/balance";
import { fetchUser } from "actions/user";
import RequireData from "hooks/RequireData";
import SageScreen from "kit/SageScreen";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import createTransferStatusSelector from "selectors/createTransferStatus";
import fetchUserStatusSelector from "selectors/fetchUserStatus";
import userSelector from "selectors/user";
import { centHundredthsToString } from "utils/moneyFormat";
import BalanceMoneyCreateTransferForm from "./balanceMoneyCreateTransfer/BalanceMoneyCreateTransferForm";
import BalanceMoneyCreateTransferSuccess from "./balanceMoneyCreateTransfer/BalanceMoneyCreateTransferSuccess";

const BalanceMoneyCreateTransfer: React.FC = () => {
    const dispatch = useDispatch();

    const [user] = RequireData(
        userSelector,
        fetchUserStatusSelector,
        fetchUser()
    );

    React.useEffect(() => {
        dispatch(setCreateTransferStatus("none"));
    }, [dispatch]);

    const createTransferStatus = useSelector(createTransferStatusSelector);

    return (
        <SageScreen>
            <h2>Transfer to Your Bank</h2>
            <p>
                Create a transfer of the money in your Rend A Hand account to
                another account.{" "}
                {user && (
                    <span>
                        Your have{" "}
                        {centHundredthsToString(
                            user.money_balance_cent_hundredths
                        )}{" "}
                        in your account
                    </span>
                )}
            </p>
            {createTransferStatus === "success" ? (
                <BalanceMoneyCreateTransferSuccess />
            ) : (
                <BalanceMoneyCreateTransferForm />
            )}
        </SageScreen>
    );
};

export default BalanceMoneyCreateTransfer;
